import { PostAPI } from 'Components/Helper/Helpers';

export const SelectMenuDropDown = async (request) => {
    return PostAPI(request, 'SupportMenu/SelectMenuDropDown');
};

export const Insert = async (request) => {
    return PostAPI(request, 'SupportMenu/Insert');
};

export const Select = async (request) => {
    return PostAPI(request, 'SupportMenu/Select');
};

export const Delete = async (request) => {
    return PostAPI(request, 'SupportMenu/Delete');
};
